const siteTitle = 'Terminez votre commande';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Renseignez vos informations',
    formTitle2: 'Vous payez ici',
    btnForm: 'Continuer',
    btnForm2: 'Payer',
    priceText1: 'Paiement',
    priceText2: 'Total',
    footerTitle: 'Paiement en ligne',
    footerText: 'Confirmez avec votre carte de crédit',
  },
  home: {
    placeholder: {
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'Email',
      phone: 'Téléphone',
      city: 'Ville',
      address: 'Adresse',
      zip: 'Code postal',
      continue: 'Continuer',
      name: 'Nom',
    },
    cardNumber: 'Numéro de carte',
    expirationDate: "Date d'expiration",
    name: 'Nom',
    month: 'mois',
    year: 'année',
    cvv: 'CVV',
    confirmPayment: 'Confirmer le paiement',
  },
  validation: {
    requireEmail: 'Votre email est vide',
    validEmail: 'Le courriel est invalide',
    requirePhone: 'Votre téléphone est vide',
    minPhone: 'Le champ du téléphone doit comporter au moins 10 caractères.',
    requireFirstName: 'Le prénom est requis.',
    validFirstName: 'Le prénom est invalide.',
    requireLastName: 'Le champ Nom de famille est obligatoire.',
    validLastName: "Le champ Nom de famille n'est pas valide.",
    requireCity: 'Il campo della città è richiesto.',
    validCity: 'Le champ de la ville est invalide.',
    requireAddress: "Le champ d'adresse est obligatoire.",
    validAddress: "Le champ d'adresse est invalide.",
    requireZip: 'Le champ code postal est obligatoire.',
    validZip: "Le champ zip n'est pas valide.",
    requireCard: 'Le champ du numéro de carte est obligatoire.',
    minCard: 'Pas assez de symboles.',
    validCard: 'Le champ du numéro de carte est invalide.',
    requireMonth: "Le champ mois d'expiration est requis.",
    requireYear: "Le champ année d'expiration est obligatoire.",
    requireName: 'Il est requis de compléter le champ correspondant au nom.',
    validName: "Le champ de nom n'est pas valide.",
    requireCvv: 'Le champ cvv est obligatoire.',
    validCvv: "Le champ CVV n'est pas valide.",
    minFirstName:
      'Le champ du premier nom doit comporter au moins 3 caractères.',
    minLastName:
      'Le champ du nom de famille doit comporter au moins 3 caractères.',
    minCity: 'Le champ de la ville doit comporter au moins 3 caractères.',
    minAddress: "Le champ d'adresse doit comporter au moins 3 caractères.",
    minZip: 'Le champ du code postal doit comporter au moins 3 caractères.',
    minName: 'Le champ du nom doit comporter au moins 3 caractères.',
    minCvv: 'Le champ cvv doit comporter au moins 3 caractères.',
    specialFirstName:
      'Le champ du prénom ne doit pas contenir de caractères spéciaux',
    specialLastName:
      'Le nom de famille du champ ne doit pas contenir de caractères spéciaux',
    specialName: 'Le nom du champ ne doit pas contenir de caractères spéciaux',
    specialCity:
      'La ville de terrain ne doit pas contenir de caractères spéciaux',
  },
  mask: {
    phone: '+32 999 999 999',
    zip: '9999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'ENTRER EN CONTACT',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    email: 'E-mail',
    msg: 'Message',
    send: 'Envoyer',
    alreadyRegistered: 'Vous êtes déjà inscrit',
    unsubscribeLink: 'lien de désinscription',
    worktime: "Centre d'appels Fonctionne de 10h à 17h",
    phone: 'Téléphone: Sofia +359 2 437 4207',
  },
};
